import React from 'react';
import { Container, Grid, Box, Typography, TextField, Button, Paper, Stack, Snackbar, Alert, InputAdornment } from '@mui/material';
import { API_BASE } from '../config';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

export default function Contact() {
  const [form, setForm] = React.useState({ name: '', company: '', email: '', phone: '', message: '' });
  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const validate = () => {
    const e = {};
    if (!form.name) e.name = 'Please enter your name';
    if (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Enter a valid email';
    if (!form.message) e.message = 'Tell us how we can help';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChange = (k) => (ev) => setForm(f => ({ ...f, [k]: ev.target.value }));

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    try {
      await fetch(`${API_BASE}/api/contact`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
      setOpen(true);
      setForm({ name: '', company: '', email: '', phone: '', message: '' });
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container sx={{ py: { xs: 4, md: 8 } }}>
      <Grid container spacing={4} alignItems="flex-start">
        <Grid item xs={12} md={6}>
          <Box sx={{ maxWidth: 680 }}>
            <Typography variant="h3" sx={{ fontWeight: 800, mb: 2 }}>Contact Us</Typography>
            <Typography variant="h6" sx={{ color: 'text.secondary', mb: 3 }}>Get in touch with NehaInfoTech for business inquiries, support, or partnership opportunities.</Typography>

            <Paper elevation={0} sx={{ p: 3, bgcolor: 'transparent' }}>
              <Stack spacing={1}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Office</Typography>
                <Typography>No 9B, Block 11, Neyveli TS, Tamil Nadu, India - 607803</Typography>
                <Typography>info@nehainfotech.com</Typography>
                <Typography>+91-9345444973</Typography>
              </Stack>
            </Paper>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: { xs: 2.5, md: 4 }, borderRadius: 2 }} elevation={3}>
            <form onSubmit={handleSubmit} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField label="Your name" value={form.name} onChange={handleChange('name')} fullWidth error={!!errors.name} helperText={errors.name} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Company" value={form.company} onChange={handleChange('company')} fullWidth />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    variant="outlined"
                    value={form.email}
                    onChange={handleChange('email')}
                    fullWidth
                    error={!!errors.email}
                    helperText={errors.email}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon color={errors.email ? 'error' : 'action'} />
                        </InputAdornment>
                      )
                    }}
                    InputLabelProps={{ sx: { transition: 'all 180ms ease' } }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Phone"
                    variant="outlined"
                    value={form.phone}
                    onChange={handleChange('phone')}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneIcon color="action" />
                        </InputAdornment>
                      )
                    }}
                    InputLabelProps={{ sx: { transition: 'all 180ms ease' } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField label="Message" value={form.message} onChange={handleChange('message')} fullWidth multiline rows={6} error={!!errors.message} helperText={errors.message} />
                </Grid>

                <Grid item xs={12}>
                  <Button type="submit" variant="contained" color="primary" fullWidth disabled={submitting} sx={{ py: 1.5, borderRadius: 2 }}>Send Message</Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>

      <Snackbar open={open} autoHideDuration={4000} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity="success" sx={{ width: '100%' }}>Thanks — we received your message and will respond shortly.</Alert>
      </Snackbar>
    </Container>
  );
}
